import { render, staticRenderFns } from "./ProductNameCell.vue?vue&type=template&id=0a218826&scoped=true"
import script from "./ProductNameCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductNameCell.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductNameCell.vue?vue&type=style&index=0&id=0a218826&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a218826",
  null
  
)

export default component.exports